import script from "./FaqsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqsView.vue?vue&type=script&setup=true&lang=js"

import "./FaqsView.vue?vue&type=style&index=0&id=ceb1eda2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceb1eda2"]])

export default __exports__